import Navigation from './Navigation.svelte';

const buildNavigation = () => {
  cube.$$('.js-navigation-button').forEach(btn => {
    btn.off('mouseover', buildNavigation);
    btn.off('focus', buildNavigation);
  });

  cube.$('.navigation__close').on('click', () => {
    cube.$('html').classList.remove('navigation-on');
    if(cube.$('.menu-button')){
      cube.$('.menu-button').setAttribute('aria-expanded', 'false');
    }
  });

  const placeholder = cube.$('#js-navigation');
  const scriptHolder = cube.$('#json-navigation');
  const json = JSON.parse(scriptHolder.dataset.navigation);
  const storeInfos = JSON.parse(scriptHolder.dataset.storeInfos);
  const { backgroundSrc, keepNavigationLevel } = scriptHolder.dataset;
  const defaultSport =
    keepNavigationLevel && tc_vars && tc_vars.page_cat2
      ? tc_vars.page_cat2
      : null;

  return new Navigation({
    target: placeholder,
    props: { json, defaultSport, storeInfos, backgroundSrc },
    hydrate: true,
  });
};

export const init = () => {
  cube.$$('.js-navigation-button').forEach(btn => {
    btn.on('mouseover', buildNavigation);
    btn.on('focus', buildNavigation);
  });
};



// WEBPACK FOOTER //
// ./src/commons/navigation/navigation.js